/*
 * onglets-produit-records.js
 * Comportement des onglets de sections/onglets-produit-records.liquid.
 *
 * Element personnalise plutot que fonction d'initialisation : le navigateur
 * appelle connectedCallback des que l'element entre dans le document, donc
 * aussi quand l'editeur de theme reinjecte la section. Pas besoin d'ecouter
 * shopify:section:load, et aucun risque d'ecouteur pose deux fois sur la
 * meme instance : les ecouteurs vivent et meurent avec l'element.
 *
 * Meme fichier pour toutes les instances de la section : chaque element gere
 * ses propres onglets, rien n'est partage.
 */

if (!customElements.get('onglets-produit-records')) {
  class OngletsProduitRecords extends HTMLElement {
    connectedCallback() {
      // Un element deplace dans le DOM est reconnecte : on ne rebranche pas.
      if (this.pret) return;

      this.onglets = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panneaux = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.onglets.length === 0) return;

      this.pret = true;

      this.onglets.forEach((onglet, index) => {
        onglet.addEventListener('click', () => this.activer(index, false));
        onglet.addEventListener('keydown', (evenement) => this.auClavier(evenement, index));
      });

      // L'etat de depart est deja rendu par Liquid (premier onglet ouvert,
      // panneaux suivants avec l'attribut hidden) : on se contente de le
      // relire, ce qui evite tout clignotement au chargement.
      const actif = this.onglets.findIndex((onglet) => onglet.getAttribute('aria-selected') === 'true');
      this.activer(actif >= 0 ? actif : 0, false);
    }

    /* index : onglet a ouvrir. donnerLeFocus : vrai quand l'appel vient du
       clavier, ou le focus doit suivre l'onglet selectionne. */
    activer(index, donnerLeFocus) {
      this.onglets.forEach((onglet, i) => {
        const estActif = i === index;
        onglet.classList.toggle('optr__tab--actif', estActif);
        onglet.setAttribute('aria-selected', estActif ? 'true' : 'false');
        // Tabindex glissant : un seul onglet dans l'ordre de tabulation, les
        // autres s'atteignent aux fleches.
        onglet.tabIndex = estActif ? 0 : -1;

        const panneau = this.panneaux[i];
        if (panneau) {
          panneau.classList.toggle('optr__panel--actif', estActif);
          panneau.hidden = !estActif;
        }
      });

      if (donnerLeFocus) this.onglets[index].focus();
    }

    auClavier(evenement, index) {
      const dernier = this.onglets.length - 1;
      let cible = null;

      if (evenement.key === 'ArrowRight') cible = index === dernier ? 0 : index + 1;
      else if (evenement.key === 'ArrowLeft') cible = index === 0 ? dernier : index - 1;
      else if (evenement.key === 'Home') cible = 0;
      else if (evenement.key === 'End') cible = dernier;

      if (cible === null) return;

      // Sans cela, Home et End feraient defiler la page sous les onglets.
      evenement.preventDefault();
      this.activer(cible, true);
    }

    /* Appelee par l'editeur de theme quand un bloc est selectionne. */
    ouvrirParBloc(blocId) {
      const index = this.onglets.findIndex((onglet) => onglet.dataset.blocId === blocId);
      if (index >= 0) this.activer(index, false);
    }
  }

  customElements.define('onglets-produit-records', OngletsProduitRecords);

  // Un seul ecouteur pour toute la page, pose au chargement du fichier :
  // l'editeur peut recharger la section autant de fois qu'il veut, cet
  // ecouteur-la ne se duplique pas.
  document.addEventListener('shopify:block:select', (evenement) => {
    const racine = evenement.target.closest('onglets-produit-records');
    if (racine && typeof racine.ouvrirParBloc === 'function') {
      racine.ouvrirParBloc(evenement.detail.blockId);
    }
  });
}
